'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = AccordionTitle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icon = require('../icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_icon.Icon, {
    className: 'sb-accordion__dropdown',
    name: 'arrow-down-slim'
});
// components


/**
 * WH AccordionTitle Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function AccordionTitle(props) {
    var children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        onClick = props.onClick;


    return (0, _jsx3.default)('header', {
        className: 'sb-accordion__header',
        onClick: onClick,
        id: id
    }, void 0, children, _ref);
}
//# sourceMappingURL=AccordionTitle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/accordion/AccordionTitle.js
// module id = 543
// module chunks = 0